<template>
  <div id="management-queue">
    <div class="table-section">
      <el-card class="box-card" shadow="never">
        <el-form
          :inline="true"
          :model="searchParams"
          class="form-inline"
          
        >
          <el-form-item label="业务类型">
            <el-select
              v-model.trim="searchParams.businessType"
              placeholder="业务类型"
            >
              <el-option
                v-for="item in businessTypeList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input
              v-model.trim="searchParams.contractNumber"
              placeholder="合同编号"
            />
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input
              v-model.trim="searchParams.userName"
              placeholder="客户姓名"
            />
          </el-form-item>
          <el-form-item label="处理人">
            <el-autocomplete
              v-model="operator"
              :fetch-suggestions="querySearch"
              placeholder="处理人"
              @select="handleSelect"
              @change="operatorChange"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchParams.divisionStatus" placeholder="状态">
              <el-option
                v-for="item in divisionStatusList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="clear">清空</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="downLoadExcel">模板下载</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload
              ref="upload"
              :limit="1"
              :action="path"
              :data="uploadParams"
              :on-success="handleSuccess"
              :show-file-list="false"
            >
              <el-button type="primary" >人工分案</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <div class="table-section">
      <el-table
        :data="manageBatchTasksList"
        :header-row-style="headerRowStyle"
        border
        highlight-current-row
        max-height="550px"
      >
        <el-table-column prop="businessType" label="业务类型">
          <template slot-scope="scope">
            {{
              scope.row.businessType === "1"
                ? "爱分担"
                : scope.row.businessType === "2"
                ? "分担宝"
                : scope.row.businessType === "3"
                ? "助贷通道"
                : scope.row.businessType === "4"
                ? "好易付"
                : scope.row.businessType === "5"
                ? "实物租赁"
                : scope.row.businessType === "6"
                ? "乐享付"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="contractNumber" label="合同编号" width="240" />
        <el-table-column prop="borrowerName" label="客户姓名" />
        <el-table-column prop="bindingAgentName" label="处理人" />
        <el-table-column prop="divisionStatus" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.divisionStatus === "0"
                ? "处理中"
                : scope.row.divisionStatus === "1"
                ? "成功"
                : scope.row.divisionStatus === "2"
                ? "失败"
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="failureReason" label="失败原因" />
      </el-table>
    </div>

    <div class="pagination-section">
      <el-pagination
        :page-size="pageSize"
        :total="manageBatchTasksListTotalCount"
        layout="total, prev, pager, next"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getDictionaryList, getUser } from "@/api/manage";
import api from "../../api.js";

export default {
  name: "batchTasks",
  data() {
    return {
      headerRowStyle: {
        "background-color": "#6584b4",
      },
      operator: "",
      searchParams: {},
      pageSize: 20,
      page: 0,
      businessTypeList: [],
      divisionStatusList: [
        {
          label: "处理中",
          value: "0",
        },
        {
          label: "成功",
          value: "1",
        },
        {
          label: "失败",
          value: "2",
        },
      ],
      path: "api/task/importManualDivisionTasks",
      uploadParams: {},
    };
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "manageBatchTasksList",
      "manageBatchTasksListTotalCount",
    ]),
  },
  async created() {
    this.uploadParams.operator = this.currentUser.id;
    this.loadBatchTasks();
    const fdBusinessTypeRes = await getDictionaryList("fd_business_type");
    fdBusinessTypeRes.data.map((item) => {
      this.businessTypeList.push({
        label: item.dictLabel,
        value: item.dictValue,
      });
    });
  },
  methods: {
    ...mapActions(["fetchManageBatchTasks"]),
    loadBatchTasks() {
      return this.fetchManageBatchTasks({
        searchParams: this.searchParams,
        page: this.page,
        size: this.pageSize,
        userId: this.currentUser.id,
        divisionType: 2
      });
    },
    changePage(currentPage) {
      this.page = currentPage;
      this.loadBatchTasks();
    },
    search() {
      this.page = 1;
      this.loadBatchTasks();
    },
    clear() {
      this.operator = "";
      this.searchParams = {};
      this.search();
    },
    // 处理人
    async querySearch(queryString, cb) {
      const results = [];
      if (queryString) {
        const getUserRes = await getUser(queryString);
        if (getUserRes.data.length > 0) {
          getUserRes.data.map((item) => {
            results.push({
              value: item.name,
              id: item.id,
            });
          });
        }
      }
      cb(results);
    },
    handleSelect(item) {
      this.searchParams.bindingAgentId = item.id;
    },
    operatorChange(val) {
      if (!val) {
        this.searchParams.bindingAgentId = "";
      }
    },
    // 人工分案导入模板下载
    downLoadExcel() {
      api.downManualDivisionTasksTemplate();
    },
    // 人工分案
    handleSuccess(res) {
      if (res.code === "00") {
        this.$message.success(res.data);
        this.loadBatchTasks();
        return;
      }
      this.$message.error(res.data);
    },
  },
};
</script>
